// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ed37c777b9cb8b82d39a","453":"392df16ebef96268177d"}[chunkId] + ".js";
};